/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { representativesGet } from "../../funcs/representativesGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetRepresentativeRequest$inboundSchema,
};

export const tool$representativesGet: ToolDefinition<typeof args> = {
  name: "representatives-get",
  description:
    `Retrieve a specific representative associated with a given Moov account. Read our [business representatives guide](https://docs.moov.io/guides/accounts/requirements/business-representatives/) to learn more.

To access this endpoint using an [access token](https://docs.moov.io/api/authentication/access-tokens/) 
you'll need to specify the \`/accounts/{accountID}/representatives.read\` scope.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await representativesGet(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
